<template>
  <b-modal
    id="modal-feddback-remark-view"
    ref="modal"
    v-model="open"
    size="ov-custom"
    no-close-on-backdrop
    hide-footer
    centered
    :title="`VIEW FEEDBACK REMARK`"
  >
    <b-overlay
      :show="modalLoading"
      blur="10px"
      opacity="0.30"
      rounded="sm"
      variant="light"
    >
      <feedback-remark-table
        :remarks="items"
        :order-id="id"
        :data-loading="dataLoading"
      />
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BModal,
  BOverlay,
  VBModal,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import FeedbackRemarkTable from '@/components/orders/remarks/FeedbackRemarkTable.vue'

const remarkRepository = RepositoryFactory.get('feedbackRemark')

function initialState() {
  return {
    open: false,
    id: null,
    modalLoading: false,
    items: [],
    dataLoading: false,
  }
}

export default {
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  components: {
    BModal,
    BOverlay,
    FeedbackRemarkTable,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return initialState()
  },
  methods: {
    async openModal(id) {
      Object.assign(this.$data, initialState())
      this.open = true
      this.id = id
      await this.fetchRemarkDetails()
    },
    async fetchRemarkDetails() {
      this.dataLoading = true
      try {
        const { data } = (await remarkRepository.getRemarkList(this.id)).data
        this.items = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.dataLoading = false
    },
  },
}
</script>
<style scoped>
</style>
